import { createAsyncThunk } from "@reduxjs/toolkit";

import promotionService from "services/api/promotion";

import { sliceName } from "./initialState";

import { setUsePromotionAction } from "./actions";

export const promotionRulesThunk = createAsyncThunk(
	`${sliceName}/promotionRules`,
	async (promotionType, { signal }) => {
		const response = await promotionService.rules(promotionType, signal);

		return response.data.value;
	}
);
